import "@mks/dev/localization/globalize/number";
import "@mks/dev/localization/globalize/date";
import "@mks/dev/localization/globalize/currency";
import "@mks/dev/localization/globalize/message";
import "@DwhRoot/js/localization/mks-richedit.ru.js";
import supplemental from "@mks/dev-cldr-data/supplemental.json";
import cldr_en      from "@mks/dev-cldr-data/en.json";
import cldr_ru      from "@mks/dev-cldr-data/ru.json";
import messages_en  from "@mks/dev/localization/messages/en.json";
import messages_ru  from "@mks/dev/localization/messages/ru.json";
import Globalize    from "globalize";
import jquery       from "jquery";

import { loadMessages as dxLoadMessages } from '@mks/dev/localization';
import { loadMessages as analyticsLoadMessages } from '@mks/analytics-core/analytics-localization';
import { patchExpressionEditorDescriptions } from '@Views/Dashboard/Common/LocalizationUtils/ExpressionEditorLocalizationUtils';

function localizeCore(culture) {
    if (culture === 'en') {
        Globalize.load(supplemental, cldr_en);
        Globalize.loadMessages(messages_en);
        Globalize.locale('en');
    }
    else {
        Globalize.load(supplemental, cldr_ru);
        Globalize.loadMessages(messages_ru);
        Globalize.locale('ru');
    }

    patchExpressionEditorDescriptions();
    window.Globalize = Globalize;
}

export async function localizeKsaAsync(culture, resourceUrl) {
    try {
        localizeCore(culture);
        const data = await jquery.post(resourceUrl);
        dxLoadMessages(data.base);
        analyticsLoadMessages(data.analytics);
    }
    catch (error) {
        console.log('Localization error:', error);
    }
}

export async function localizeKsaLoginAsync(culture, resourceUrl) {
    try {
        localizeCore(culture);
        const data = await jquery.post(resourceUrl);
        dxLoadMessages(data);
    }
    catch (error) {
        console.log('Localization error:', error);
    }
}
